import { NgModule, Injector } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { AuthGuard } from './auth/guards/auth.guard';
import { RedirectComponent } from './auth/redirect/redirect.component';
import { LoginComponent } from './login/login.component';
import { OktaAuthService, OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { AuthenticationService } from './services/authentication.service';

const config = {
  url: window['__ccpEnv'].SSODomain,
  issuer: window['__ccpEnv'].SSODomain + '/oauth2/default',
  clientId: window['__ccpEnv'].SSOClientId,
  redirectUri: window['__ccpEnv'].uiDomain + '/sso.html',
  postLogoutRedirectUri: window['__ccpEnv'].uiDomain + '/ssoLogout.html',
  scopes: ['openid', 'email', 'profile'],
  tokenManager: {
    autoRenew: false,
    secure: true,
    storage: 'localStorage'
  },
  pkce: false,
  onAuthRequired: (oktaAuth: OktaAuthService, injector: Injector) => {
    const router = injector.get(Router);
    const authenticationService = injector.get(AuthenticationService);
    authenticationService.updateAuthenticationState(false);
    router.navigate(['login']);
  }
}

const routes: Routes = [
  { path: '', component: RedirectComponent, canActivate: [AuthGuard], pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  // otherwise redirect to home
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true, scrollPositionRestoration: 'enabled' }),
    OktaAuthModule
  ],
  providers: [
    AuthGuard,
    { provide: OKTA_CONFIG, useValue: config }
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
